import { Signal } from '@preact/signals-react'
import { TagItemsProps, TagItemType } from '../components/TagItems/TagItems'
import { Subscription } from '../../core/Subscription'
import { UpdatableReactElement } from '../../utils/react.utils'
import { BlockComponentProps } from '../core/types'
import { CSSProperties } from 'react'

export type BlockStyleProps = {
    style?: CSSProperties
}

export enum BlockStateFormatKey {
    Default = 'default',
    Html = 'html',
    Markdown = 'markdown',
}

export type BlockOptions = {
    id: string
    name: string
    componentProps?: Record<string, unknown>
}

export enum BlockEventSubscriptionType {
    RefAdded = 'ref-added',
}
export interface ITaskBlock {
    type: string
    name: string
    id: string
    subscription: Subscription<BlockEventSubscriptionType, never>
    getElement: () => UpdatableReactElement | undefined
    render: () => void
    updateProps?: (newProps: Partial<BlockComponentProps<unknown> & BlockStyleProps>) => void
    getProps: () => Record<string, unknown> | undefined
    show: () => void
    hide: () => void
    clear: () => void
    getState: (key: string) => Signal<unknown>
    setState: (key: string, value: unknown) => void
    getListener: (key: string) => Signal<((...args: unknown[]) => unknown) | undefined>
    setListener: (key: string, listener: ((...args: unknown[]) => unknown) | undefined) => void
    getListeners: () => Record<string, Signal<((...args: unknown[]) => unknown) | undefined>>
    executeMethod: (key: string, ...args: unknown[]) => unknown
    setTags: (tagId: string, item: TagItemType | undefined) => void
    getTags: () => TagItemsProps['items']
    getRefContainer: () => HTMLElement | null
}
